export const QuizData = [
    {
        question: "Which Company made React JS?",
        options: ["Microsoft", "Facebook", "Apple", "Google"],
        answer: 2
    },
    {
        question: "Which language is grandfather of website?",
        options: ["C", "Python", "JavaScript", "Java"],
        answer: 3
    }, {
        question: "Which company owns GitHub?",
        options: ["Facebook", "Google", "Microsoft", "Apple"],
        answer: 3
    },
    {
        question: "What is the full form of JS?",
        options: ["JockerSnake", "JavaSql", "JemScript", "JavaScript"],
        answer: 4
    },
    {
        question: "Who Made this Game?",
        options: ["Elon", "Mark", "Sahil", "Amit"],
        answer: 3
    }
]

export default QuizData;